import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  FormGroup,
  Label,
} from "reactstrap";
import { collection, getDocs, addDoc, query, where } from "firebase/firestore";
import { getDb } from "../../../util/Constants";
import Swal from "sweetalert2";

export default function AddMiniGame3Modal({ isOpen, toggle, onQuestionAdded }) {
  const [question, setQuestion] = useState("");
  const [loading, setLoading] = useState(false);
  const [nextNumber, setNextNumber] = useState(1);

  useEffect(() => {
    if (isOpen) {
      setQuestion("");
      setLoading(false);
      (async () => {
        const q = query(
          collection(getDb(), "questions"),
          where("miniGame", "==", "Mini 3")
        );
        const snapshot = await getDocs(q);
        let max = 0;
        snapshot.forEach((doc) => {
          const num = Number(doc.data().questionNumber);
          if (!isNaN(num) && num > max) max = num;
        });
        console.log(max, "max");
        setNextNumber(max + 1);
      })();
    }
  }, [isOpen]);

  const handleAdd = async () => {
    if (!question.trim()) {
      Swal.fire("Error", "Question cannot be empty", "error");
      return;
    }
    setLoading(true);
    try {
      await addDoc(collection(getDb(), "questions"), {
        miniGame: "Mini 3",
        question: question.trim(),
        questionNumber: nextNumber,
      });
      setLoading(false);
      toggle();
      if (onQuestionAdded) onQuestionAdded();
      Swal.fire("Success", "Question added!", "success");
    } catch (e) {
      setLoading(false);
      Swal.fire("Error", "Failed to add question", "error");
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>Add Mini Game 3 Question</ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label for="questionInput" style={{ fontWeight: 600, fontSize: 16 }}>
            Question
          </Label>
          <Input
            id="questionInput"
            type="text"
            value={question}
            onChange={(e) => setQuestion(e.target.value)}
            placeholder="Enter your question here..."
            style={{
              borderRadius: 8,
              fontSize: 18,
              padding: "14px 16px",
              border: "2px solid #007bff",
              boxShadow: "0 2px 8px #e3e3e3",
              marginTop: 8,
            }}
            autoFocus
          />
        </FormGroup>
        <div style={{ marginTop: 10, color: "#888" }}>
          <b>Question Number:</b> {nextNumber}
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          color="primary"
          onClick={handleAdd}
          disabled={loading || !question.trim()}
        >
          {loading ? "Adding..." : "Add Question"}
        </Button>
        <Button color="secondary" onClick={toggle} disabled={loading}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
}
